import axios from "axios"
import moment from "moment"

export const getCredit = async (username) => {
    const res = await axios.get('/api/user/credit/' + username)
    return res.data.user.credit
}

export const getClassesForTrainingProv = async (providerID) => {
    const res = await axios.get('/api/workshop/trainingProvider/' + providerID)
    // console.log("res",res,"data",res.data,"API length",res.data.length,"workshops",res.data.workshops)
    return res.data.workshops
}

/// this grabs a list of all the possible options for categories, orgs, instrucs, lead instrucs,
/// locations, contacts, and programs
export const getTrainingProviderOptions = async () => {

    const categories = []
    const organizations = []
    const instructors = []
    const leadInstructors = []
    const locTemplates = []
    const contactTemplates = []
    const programs = []
    const states = []

    const res = await axios.all([
        axios.get('/api/category'),
        axios.get('/api/organization'),
        axios.get('/api/instructor/search'),
        axios.get('/api/locationTemplate/'),
        axios.get('/api/contactTemplate/'),
        axios.get('/api/program/'),
        axios.get('/api/stateCounty/states')
    ])

    res[0].data.categories.forEach((u) => {
        // added categoryCode to categories list
        categories.push({ label: u.categoryName, value: u.ID, categoryCode: u.categoryCode });
        //categoryCodeMap[u.ID] = u.categoryCode;
    });
    res[1].data.organizations.forEach((u) => {
        //organizations.push({ label: u.organizationName, value: u.ID });
        organizations.push({ label: u.organizationName, value: u.ID, categoryId: u.categoryId, organizationCode: u.organizationCode });
    });
    res[2].data.instructors.forEach((u) => {
        instructors.push({ label: u.name, value: u.username });
        if (u.instructorLevel === 'Certified Instructor' || u.instructorLevel === 'Senior Instructor') {
            leadInstructors.push({ label: u.name, value: u.username });
        }
    });
    res[3].data.locTemplates.forEach((u) => {
        locTemplates.push({ label: u.name, value: u.ID });
    });
    res[4].data.templates.forEach((u) => {
        contactTemplates.push({ label: u.lastName + ', ' + u.firstName, value: u.ID });
    });
    res[5].data.program.forEach((u) => {
        programs.push({ label: u.title, value: u.ID });
    });
    res[6].data.states.forEach((u) => {
        states.push({ label: u, value: u});
    });
    return {
        categories,
        organizations,
        instructors,
        leadInstructors,
        locTemplates,
        contactTemplates,
        programs,
        states
    }
}

// takes in a program and the existing module presenters. Returns the module presenters for the program, if there is overlap
// then sets the ones with overlap to the existing module presenters
export const getModulePresentersForProgram = async (program, modulePresenters) => {
    const res = await axios.get('/api/program/' + program.value)

    let index = -1;
    let mp = res.data.modules.map((u) => {
        index = modulePresenters.findIndex(e => e.moduleId === u.ID); // handles overlap between existing module presenters and new ones
        if (index > -1) {
            return {
                moduleId: u.ID,
                moduleName: u.moduleName,
                instructorName: modulePresenters[index].instructorName,
                instructorId: modulePresenters[index].instructorId
            };
        } else {
            return {
                moduleId: u.ID,
                moduleName: u.moduleName,
                instructorName: null,
                instructorId: null
            };
        }
    })

    return mp

}


/// takes in the options for trainingProvider, and gets the data for the specfic training provider
export const getTrainingProviderData = async (ID, options) => {
    const {
        categories,
        organizations,
        leadInstructors,
        locTemplates,
        contactTemplates,
        programs
    } = options

    console.log('ID from getAPI', ID)

    const res = await axios.get('/api/userGroup/' + ID)

    console.log('res from api', res)

    const group = res.data;

//    console.log('res.data', res.data)

    const { categoryID, lang, cost, minParticipants,
        maxParticipants, leadInstructorId, organizationId,
        location_id, isPublic, workshopProgram, contact_id } = res.data.usergroupClass

    return {
        // if the category is defined, only certain orgs should be available. If not, then orgs should be disabled
        organizationsFiltered: (categoryID !== null) ? organizations.filter(org => org.categoryId === categoryID) : [],

        groupName: group.usergroup.name,
        groupType: group.usergroup.type,
        groupAddress: group.location.STREET,
        groupCity: group.location.CITY,
        groupState: group.location.STATECODE,
        groupZipcode: group.location.ZIPCODE,
        groupMapURL: group.location.mapURL,

        locID: group.location.ID,

        // text fields
        lang,
        cost: cost !== undefined ? cost : '',
        minParticipants: minParticipants ? minParticipants : '',
        maxParticipants: maxParticipants !== undefined ? maxParticipants : '',
        isPublic,

        //autocomplete fields
        //using == instead of === because of the type mismatch between the array of options and the type it is stored as
        // eslint-disable-next-line 
        location_id: location_id ? locTemplates.find((json) => json.value == location_id) : null,
        // eslint-disable-next-line 
        categoryID: categoryID ? categories.find((json) => json.value == categoryID) : null,
        // eslint-disable-next-line 
        contact_id: contact_id ? contactTemplates.find((json) => json.value == contact_id) : null,
        // eslint-disable-next-line 
        workshopProgram: workshopProgram ? programs.find((json) => json.value == workshopProgram) : null,
        // eslint-disable-next-line 
        leadInstructorId: leadInstructorId ? leadInstructors.find((json) => json.value == leadInstructorId) : null,
        // eslint-disable-next-line 
        organizationId: organizationId ? organizations.find((json) => json.value == organizationId) : null,
    }
}

/// creates the trainingProvider
export const createTrainingProvider = async (data) => {
    const res = await axios('/api/usergroup', {
        method: 'POST',
        data: data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
    return res
    // if (response.status >= 400) {
    //     throw new Error(response.statusText);

}

/// updates an existing trainingProvider
export const updateTrainingProvider = async (ID, data, token) => {
    console.log("update Training provider: " +  JSON.stringify(data))
    const res = await axios('/api/usergroup/' + ID, {
        method: 'POST',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
    return res
}

/// Gets the data for a workshop given the workshop ID (not the short ID), the field options, and the languages (needs language b/c autocomplete)
export const getWorkshopData = async (ID, options, languages) => {
    const res = await axios.all([
        axios.get('/api/workshop/' + ID),
        axios.get('/api/workshopModulePresenter/workshop/' + ID),
        axios.get('/api/workshop/waiver/' + ID) // if the waiver was made or not
    ])

    console.log("Has waiver already", res[2].data.waiver ? true : false)
    console.log('res', res);
    return {
        hasWaiver: res[2].data.waiver ? true : false,

        status: res[0].data.status,

        lang: languages.find(el => el.label === res[0].data.lang),
        maxParticipants: res[0].data.maxParticipants !== null ? res[0].data.maxParticipants : '',
        minParticipants: res[0].data.minParticipants !== null ? res[0].data.minParticipants : '',
        cost: res[0].data.cost !== null ? res[0].data.cost : '',
        notes: res[0].data.notes !== null ? res[0].data.notes : '', // program details
        isPublic: res[0].data.isPublic,
        workshopID: res[0].data.workshopID,
        advertisingWebSite: res[0].data.advertisingWebSite,
        regExtUrl: res[0].data.regExtUrl,
        isRemote: res[0].data.isRemote,
        remotePlatform: res[0].data.remotePlatform,

        dates: res[0].data.dates,
        location: res[0].data.location, // this needs work

        leadInstructor: options.leadInstructors.find(el => el.label === res[0].data.leadInstructor),

        contact: res[0].data.contact, // this needs work
        // eslint-disable-next-line 
        category: options.categories.find(el => el.value == res[0].data.categoryID), // categories is a string, while id is a number
        organization: (res[0].data.organization && res[0].data.organization.categoryId === res[0].data.categoryID) ? // check that the organization exists and that the category ID of the organization matches the category id
        options.organizations.find(el => el.value === res[0].data.organization.ID) : null, //res[0].data.organization !== null ? { label: res[0].data.organization.organizationName, value: res[0].data.organization.ID } : { label: null, value: null },
        // eslint-disable-next-line 
        program: res[0].data.workshopProgram ? options.programs.find(el => el.value == res[0].data.workshopProgram.ID) : null, //res[0].data.workshopProgram !== null ? { label: res[0].data.workshopProgram.title, value: res[0].data.workshopProgram.ID } : { label: null, value: null },
        title: res[0].data.workshopProgram.title,
        description: res[0].data.workshopProgram.description, // class description
        regCloseDate: res[0].data.regCloseDate ? moment.utc(res[0].data.regCloseDate).format("YYYY-MM-DD") : '', // if null give empty string
        contactTemplate: options.contactTemplates.find(el => el.label === (res[0].data.contact.LASTNAME + ', ' + res[0].data.contact.FIRSTNAME)),
        contactFirstname: res[0].data.contact.FIRSTNAME,
        contactLastname: res[0].data.contact.LASTNAME,
        contactPhone: res[0].data.contact.PHONE,
        contactEmail: res[0].data.contact.EMAIL,
        locTemplate: options.locTemplates.find(el => el.label === res[0].data.location.NAME),
        locationName: res[0].data.location.NAME,
        locationStreet: res[0].data.location.STREET,
        locationCity: res[0].data.location.CITY,
        locationCounty: { label:res[0].data.location.COUNTYCODE, value:res[0].data.location.COUNTYCODE},
        locationStateCode: { label:res[0].data.location.STATECODE, value: res[0].data.location.STATECODE } ,
        locationZipcode: res[0].data.location.ZIPCODE,
        locationMapURL:  res[0].data.location.mapURL,
        modulePresenters: res[1].data.modulePresenters,

        audience: res[0].data.audience,
        trainingCode: res[0].data.trainingCode,
        usedBy: res[0].data.usedBy,
        trainingProviderId : res[0].data.trainingProviderId,
        byUser : res[0].data.createdByUsername,
        lastModifiedByUserName: res[0].data.lastModifiedByUsername
    }


}


/// similar to the above, except it doesn't use the options (not chaning any values)
export const getWorkshopDataForView = async (ID) => {
    try {
        const res = await axios.all([
            axios.get('/api/workshop/' + ID),
            axios.get('/api/workshopModulePresenter/workshop/' + ID),
            axios.get('/api/workshop/waiver/' + ID)
        ])
        
        return {
            workshopID: res[0].data.workshopID,
            regCloseDate: res[0].data.regCloseDate,
            lang: res[0].data.lang,
            maxParticipants: res[0].data.maxParticipants,
            minParticipants: res[0].data.minParticipants,
            cost: res[0].data.cost,
            description: res[0].data.workshopProgram ? res[0].data.workshopProgram.description : "Error",
            leadInstructor: res[0].data.leadInstructor,
            organization: res[0].data.organization ? res[0].data.organization.organizationName : "Error",
            program: res[0].data.workshopProgram ? res[0].data.workshopProgram.title : "Error",
            notes: res[0].data.notes,
            advertisingWebSite: res[0].data.advertisingWebSite,
            isPublic: res[0].data.isPublic,
            isRemote: res[0].data.isRemote,
            remotePlatform: res[0].data.remotePlatform,

            dates: res[0].data.dates,
            location: res[0].data.location,
            regExtUrl: res[0].data.regExtUrl,
            contact: res[0].data.contact,
            trainingProviderName : res[0].data.trainingProviderName,
            byUser : res[0].data.createdByUsername,
            lastModifiedByUserName: res[0].data.lastModifiedByUsername,
    
            modulePresenters: res[1].data.modulePresenters,

            waiver: res[2].data.waiver
        }
    } catch (er) {
        // handle workshop not found
        console.log(er)
        return null
    }

}

export const cancelWorkshop = async (workshopID, notes, user, data) => {
    let token = sessionStorage.getItem('accessToken');
    console.log(data)

    data = { ...data, 
        leadInstructorId: data.leadInstructor.value,
        locationStateCode: data.locationStateCode.value,
        lang: data.lang.value,
        organizationName: data.organization.label,
        cancelNotes: notes,
        byUser: user,
    }
   
    const res = await axios('/api/workshop/cancel/' + workshopID, {
      method: 'POST',
      data: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      } 
    })

    console.log("In cancel workshop", res, res.data)
    return res.data
}

export const approveWorkshop = async (workshopID, waiverID, username) => {
    console.log("Waiver ID", waiverID)
    let token = sessionStorage.getItem('accessToken');
    let data = {
        approvedBy: username,
        waiverID
    }
    const res = await axios('/api/workshop/approve/' + workshopID,  {
      method: 'POST',
      data: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      } 
    })
    console.log("DONE")
    return res
}

export const createOrUpdateWaiver = async (justification, workshopId, username, classID, classDate, leadInstructor, organization, trainingProvider) => {
    let token = sessionStorage.getItem('accessToken');
    let data = {
        requestedBy: username,
        justification,
        workshopId,
        classID,
        classDate,
        leadInstructor,
        organization,
        trainingProvider
    }
    const res = await axios('/api/workshop/waiver', {
      method: 'POST',
      data: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      } 
    })
    return res
}

// give an ID and the current user info -> if not found will use that info
export const getWaiverInfo = async (workshopId, currentUser) => {
    const res = await axios.all([
        axios.get('/api/workshop/' + workshopId),
        axios.get('/api/workshop/waiver/' + workshopId)
    ])

    let { workshopID, dates, location, leadInstructor, organization, trainingProviderId } = res[0].data

    // default values if the waiver is being created 
    let { username, first_name, last_name, email } = currentUser
    let requestedDate = moment()
    let justification, approvedBy, approvedDate = ''
    let waiverExists = false

    if (res[1].data.waiver !== null) {
        username = res[1].data.requestedUser.username
        first_name = res[1].data.requestedUser.first_name
        last_name = res[1].data.requestedUser.last_name
        email = res[1].data.requestedUser.email

        requestedDate = res[1].data.waiver.requestedDate
        justification = res[1].data.waiver.justification

        approvedBy = res[1].data.waiver.approvedBy
        approvedDate = res[1].data.waiver.approvedDate

        waiverExists = true

    }

    return {
        workshopID,
        dates,
        location,
        leadInstructor,
        organization: organization ? organization.organizationName : "Error",
        trainingProviderId,

        username,
        name: first_name + ' ' + last_name,
        email,

        requestedDate,
        justification,

        approvedBy,
        approvedDate,

        waiverID: res[1].data.waiver ? res[1].data.waiver.ID : null,

        waiverExists,
    }
}

/// this grabs a list of all the possible options for categories, orgs, lead instrucs,
export const getWorkshopAdminSearchOptions = async () => {

    const categories = []
    const organizations = []
    const instructors = []
    const leadInstructors = []
    const counties = []


    const res = await axios.all([
        axios.get('/api/category'),
        axios.get('/api/organization'),
        axios.get('/api/instructor/search'),
        axios.get('/api/stateCounty/county/FL'),
        
    ])

    res[0].data.categories.forEach((u) => {
        // added categoryCode to categories list
        categories.push({ label: u.categoryName, value: u.ID, categoryCode: u.categoryCode });
        //categoryCodeMap[u.ID] = u.categoryCode;
    });
    res[1].data.organizations.forEach((u) => {
        //organizations.push({ label: u.organizationName, value: u.ID });
        organizations.push({ label: u.organizationName, value: u.ID, categoryId: u.categoryId, organizationCode: u.organizationCode });
    });
    res[2].data.instructors.forEach((u) => {
        instructors.push({ label: u.name, value: u.username });
        if (u.instructorLevel === 'Certified Instructor' || u.instructorLevel === 'Senior Instructor') {
            leadInstructors.push({ label: u.name, value: u.username });
        }
    });
    res[3].data.forEach((u) => {
        counties.push({ label: u.stateCountyName, value: u.stateCountyName });
    });

    return {
        categories,
        organizations,
        leadInstructors,
        counties,
    }
}


   
